import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ticketing-selector-promociones',
  templateUrl: './selector-promociones.component.html',
  styleUrls: ['./selector-promociones.component.scss']
})
export class SelectorPromocionesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
